import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface WrapperProps {
  $maxHeight?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      max-height: 600px;
    `}
`;

interface GroupProps {
  $type?: 'recieved' | 'recieved-colleague' | 'sent';
}

export const Group = styled.div<GroupProps>`
  & + & {
    margin-top: ${size(3)};
  }

  ${({ $type }) =>
    $type === 'recieved'
      ? css`
          ${Bubble} {
            background-color: var(--c-accent-bg);
            color: var(--c-accent-fg);
          }
        `
      : $type === 'recieved-colleague'
        ? css`
            ${Bubble} {
              background-color: var(--c-secondary-bg);
              color: var(--c-accent-fg);
            }
          `
        : $type === 'sent'
          ? css`
              ${Main},
              ${Bubbles},
          ${BubbleItem} {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
              }

              ${Message} {
                flex-direction: row-reverse;
              }

              ${Meta} {
                padding-left: ${size(1)};
                padding-right: 0;
              }

              ${Bubble} {
                background-color: var(--c-primary-bg);
                color: var(--c-primary-fg);
              }

              ${Timestamp} {
                display: flex;
                justify-content: flex-end;
                padding-left: 0;
                padding-right: ${size(5)}; // Width of Avatar + spacing
              }
            `
          : undefined}
`;

export const Timestamp = styled.div`
  margin-top: ${size(1)};
  padding-left: ${size(5)}; // Width of Avatar + spacing
  color: var(--c-text-muted);
  font-size: ${(props) => props.theme.font.size.xsmall};
  line-height: ${(props) => props.theme.font.lineHeight.alt};
`;

export const Message = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const Meta = styled.div`
  flex-shrink: 0;
  padding-right: ${size(1)};
`;

export const Main = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const Bubbles = styled.div`
  width: 100%;
`;

export const BubbleItem = styled.div`
  max-width: 75%;

  & + & {
    margin-top: ${size(0.5)};
  }
`;

type BubbleProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  $sending?: boolean;
  $error?: boolean;
  $isImage?: boolean;
};

export const Bubble = styled.div<BubbleProps>`
  max-width: max-content;
  padding: ${size(1)} ${size(1.5)};
  background-color: var(--c-accent-bg);
  color: var(--c-accent-fg);
  border-radius: ${size(1.5)};
  font-size: ${(props) => props.theme.font.size.regular};
  line-height: ${(props) => props.theme.font.lineHeight.main};

  ${({ $isImage }) =>
    $isImage &&
    css`
      padding: 0;
      overflow: hidden;

      img {
        display: block;
        max-width: 100%;
        border-radius: ${size(1.5)};
      }
    `}

  ${({ $sending }) =>
    $sending &&
    css`
      background-color: var(--c-semantic-warning-300) !important;
      color: var(--c-semantic-warning-700) !important;

      &::before {
        content: attr(data-pending-message);
        display: block;
        font-size: ${(props) => props.theme.font.size.xxsmall};
        color: var(--c-text-muted);
        line-height: ${(props) => props.theme.font.lineHeight.alt};
      }
    `}

  ${({ $error }) =>
    $error &&
    css`
      background-color: var(--c-semantic-error-300) !important;
      color: var(--c-semantic-error-700) !important;
    `}
`;

export const BubbleHelp = styled.div`
  margin-top: ${size(0.5)};
  font-size: ${(props) => props.theme.font.size.xxsmall};
  color: var(--c-text-muted);
`;
